import {
  Badge,
  Box,
  Button,
  HStack,
  IconButton,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tooltip,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { KYDAdminEvent } from "@common/interfaces/KYDEvent";
import dayjs from "dayjs";
import { formatDate } from "../../../../utils";
import { LABELS } from "./Permissions";
import { FiEdit, FiEdit2, FiEye, FiTrash2 } from "react-icons/fi";
import { KYDOrganizationEventLink } from "@common/interfaces/KYDOrganization";
import { formatPhoneNumber } from "../../../../utils";

const LinkedOrganizationsTable = ({
  linked_organizations = [],
  isLoading = false,
  onEdit,
  onCreate,
}: {
  onEdit: (item: KYDOrganizationEventLink) => void;
  onCreate: () => void;
  linked_organizations: KYDAdminEvent["linked_organizations"];
  isLoading?: boolean;
}) => {
  return (
    <Table w="full">
      <Thead>
        <Tr>
          <Td>
            <Text
              display="table-cell"
              textTransform={"uppercase"}
              color="gray.600"
              fontSize={"small"}
              minWidth="100px"
              letterSpacing={"wider"}
              fontWeight={"bold"}
            >
              Collaborator
            </Text>
          </Td>
          <Td>
            <Text
              display="table-cell"
              textTransform={"uppercase"}
              color="gray.600"
              fontSize={"small"}
              minWidth="100px"
              letterSpacing={"wider"}
              fontWeight={"bold"}
            >
              Permissions
            </Text>
          </Td>
          <Td>
            <Text
              display="table-cell"
              textTransform={"uppercase"}
              color="gray.600"
              fontSize={"small"}
              minWidth="100px"
              letterSpacing={"wider"}
              fontWeight={"bold"}
            >
              Updated at
            </Text>
          </Td>
          <Td></Td>
        </Tr>
      </Thead>
      <Tbody>
        {linked_organizations.map((lo) => (
          <Tr key={lo.organization_id}>
            <Td>
              {lo.type === "personal"
                ? formatPhoneNumber(lo.phone_number || "")
                : lo.organization.name}
            </Td>
            <Td>
              <VStack
                w="full"
                justifyContent={"flex-start"}
                alignItems={"flex-start"}
              >
                {lo.scopes.map((scope) => (
                  <Tooltip
                    label={LABELS[scope]}
                    cursor={{ fill: "#eee" }}
                    key={scope}
                  >
                    <HStack
                      px={2}
                      _hover={{
                        background: "gray.200",
                      }}
                      borderRadius={8}
                    >
                      <Text fontSize={"xs"}>
                        {scope.replace("events/", "").replace("external/", "")}
                      </Text>
                    </HStack>
                  </Tooltip>
                ))}
              </VStack>
            </Td>
            <Td>{formatDate(dayjs(lo.updated_at))}</Td>
            <Td align="right">
              <IconButton
                isDisabled={isLoading}
                onClick={() => onEdit(lo)}
                icon={<FiEdit fontSize="1.25rem" />}
                variant="ghost"
                aria-label="Edit linked organization"
              />
            </Td>
          </Tr>
        ))}
        {linked_organizations.length === 0 ? (
          <Tr>
            <Td colSpan={5} textAlign={"center"} py={8}>
              <VStack>
                <Button onClick={() => onCreate()}>Add collaborator</Button>
              </VStack>
            </Td>
          </Tr>
        ) : null}
      </Tbody>
    </Table>
  );
};

export default LinkedOrganizationsTable;
